exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner{text-align:center;padding-top:2em}.spinner .loading-spin{display:inline-block;z-index:99;border-radius:50%;width:30px;height:30px;content:\"\";font-size:10px;text-indent:-9999em;border-top:3px solid rgba(0,0,0,.1)!important;border-right:3px solid rgba(0,0,0,.1)!important;border-bottom:3px solid rgba(0,0,0,.1)!important;opacity:.8;border-left:3px solid #446084;animation:spin .6s linear infinite;pointer-events:none;box-sizing:border-box}.spinner p{margin-top:0;text-align:center}.spinner p small{color:#9e9e9e}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
